export default __webpack_public_path__ + "static/media/trendingImg.96d49eb5.jpg";